// useFetch.js
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import Cookies from 'js-cookie';

const fetchData = async (url) => {
    const token = Cookies.get('token');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const response = await axios.get(url, { headers });
    return response.data;
};

const useFetch = (url) => {
    return useQuery({
        queryKey: [url],
        queryFn: () => fetchData(url),
        staleTime: 1000 * 60 * 5, 
        refetchOnWindowFocus: false,
        retry: false,
    });
};

export default useFetch;
